"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiveStorage = void 0;
const features = {
    sessionStorage: typeof sessionStorage !== 'undefined',
    broadcastChannel: typeof BroadcastChannel !== 'undefined',
};
class LiveStorage {
    constructor(id, initialValue) {
        this.storageId = id;
        const hydratedValue = this.hydrate();
        this.value = hydratedValue || initialValue;
        this.channel = features.broadcastChannel
            ? new BroadcastChannel(id)
            : undefined;
        if (features.broadcastChannel) {
            // Create a BroadcastChannel to sync the value updates between the clients.
            this.channel = new BroadcastChannel(this.storageId);
            this.channel.addEventListener('message', (event) => {
                switch (event.data.type) {
                    // Broadcast the current storage's value to all other storages
                    // in case of the hydrate request.
                    case 'HYDRATE': {
                        this.broadcast(this.value);
                        break;
                    }
                    case 'UPDATE': {
                        this.value = event.data.payload.nextValue;
                        // Persist the synced value, because each client keeps
                        // the value in its own session storage. That way the
                        // persistency layer auto-cleans itself when a client closes.
                        this.persist();
                        break;
                    }
                }
            });
            // Request hydration from other opened clients to pull in the value
            // when there's no hydrated value in the current session.
            if (!hydratedValue) {
                this.postMessage('HYDRATE');
            }
        }
    }
    /**
     * Broadcast the current value to other clients to inherit it.
     */
    broadcast(nextValue) {
        this.postMessage('UPDATE', {
            nextValue,
        });
    }
    update(updater) {
        const nextValue = updater(this.value);
        this.value = nextValue;
        if (features.broadcastChannel) {
            this.persist();
            this.broadcast(this.value);
        }
    }
    getValue() {
        return this.value;
    }
    serialize(value) {
        return JSON.stringify(value);
    }
    deserialize(serializedValue) {
        return JSON.parse(serializedValue);
    }
    /**
     * Flush the value into the persistency layer.
     */
    persist() {
        if (features.sessionStorage) {
            sessionStorage.setItem(this.storageId, this.serialize(this.value));
        }
    }
    /**
     * Hydrate the value from the persistency layer.
     */
    hydrate() {
        if (features.sessionStorage) {
            const storedValue = sessionStorage.getItem(this.storageId);
            return storedValue ? this.deserialize(storedValue) : null;
        }
        return this.value;
    }
    postMessage(type, ...rest) {
        if (!this.channel) {
            return;
        }
        this.channel.postMessage({
            type,
            payload: rest[0],
        });
    }
}
exports.LiveStorage = LiveStorage;
